import React from 'react'
import Main from '../../components/Agent/MyConversations/Main'
import SingleSelect from '../../components/Common/DropDown/SingleSelect'
import styles from '../../styles/agent/MyConversations.module.css'


const MyConversations = () => {

    return (
        <div className="container bodyContainer">
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <h1 className={`page-heading page-header ${styles.pageHeader} text-uppercase m-0`}>my conversations</h1>
                </div>
                <div className="d-flex align-items-center">
                    <div className={`d-flex align-items-center bg-white ${styles.searchConversation} pe-2 me-2`} role="search">
                        <input className="form-control me-2 border-0 me-0" type="search" placeholder="Search Conversation..." aria-label="Search" />
                        <i className="bi bi-search"></i>
                    </div>
                    <SingleSelect options={['Most Recent', 'Oldest']} />
                    <button type="button" className={`ms-2 bg-white btn ${styles.exportToCSVBtn}`}>
                        <i className={`bi bi-file-earmark-arrow-down pe-1 ${styles.csvDownloadIcon}`}></i>Export as CSV
                    </button>
                </div>
            </div>
            <div className={`${styles.container}`}>
               <Main />
            </div>
        </div>
    )
}

export default MyConversations
